import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 4rem 0;
  background-color: ${({ theme }) => theme.colors.black[300]};

  p {
    font-family: ${({ theme }) => theme.fonts.secondary};
    margin-top: unset;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.grey[0]};

    &:last-child {
      margin-bottom: unset;
    }
  }

  @media print {
    display: none;
  }
`;

export const Links = styled.div`
  display: block;
  align-items: flex-start;

  @media (max-width: 960px) {
    margin-top: 2rem;
  }

  a {
    color: ${({ theme }) => theme.colors.grey[0]};
    display: block;
    margin-bottom: 0.5rem;
    font-size: 12pt;
    font-family: ${({ theme }) => theme.fonts.secondary};
  }
`;

export const SubItem = styled.div`
  margin-right: 3rem;

  &:last-child {
    margin-right: unset;
  }
`;

export const Address = styled.div`
  margin: 1rem 0;
  p {
    line-height: 0.4rem;
  }
`;

export const Phone = styled.a`
  color: ${({ theme }) => theme.colors.grey[0]};
  display: block;
  margin-bottom: 0.5rem;
  font-size: 12pt;
  font-family: ${({ theme }) => theme.fonts.secondary};
`;

export const Email = styled.a`
  color: ${({ theme }) => theme.colors.grey[0]};
  display: block;
  margin-bottom: 0.5rem;
  font-size: 12pt;
  font-family: ${({ theme }) => theme.fonts.secondary};
`;

export const Option = styled.div`
  &:hover {
    cursor: pointer;
  }
`;
